import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Badge, DataTable, SearchInput, Spin, useAlert } from '../ui';
import { DataTableColumn } from '../ui/DataTable';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import datas from "../../Assets/data.json";
import Generate from '../Qm/Generate';
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import AddEntite from './Buttons/AddEntite';
import FormEntiteUpdate from './Forms/FormEntiteUpdate';
import FormDrawer from '../ui/FormDrawer';
import InfoBar from '../ui/InfoBar';
import PageHeader from '../ui/PageHeader';
import TableStatusBar from '../ui/TableStatusBar';
import UpdateEntite from './Buttons/UpdateEntite';
import BlockDeblockEntite from './Buttons/BlockDeblockEntite';

export default function GestionEntite() {

    // USER TOKEN
    const authHeader = useAuthHeader()

    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert()

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [data, setData] = useState([])

    const [arrierePlan, setArrierePlan] = useState([])
    const [arrierePlanSelected, setArrierePlanSelected] = useState<any>()

    const [dataTri, setDataTri] = useState<any>([])

    const [loading, selLoading] = useState(false)
    const [textRes, setTextRes] = useState("")



    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        LoadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function Search(search: string) {
        const data = {
            Critere: search,
            CodeAbonne: user.CodeAbonne
        }
        if (search.length == 0) {
            LoadData()
        }
        else {
            selLoading(true)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: env.API_BASE_URL + datas.API_LINKs.GetFilialeBy + Crypter.encrypt(JSON.stringify(data)),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                }
            };

            axios.request(config)
                .then((response: any) => {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value
                    if (res.StatutCode == 200) {
                        selLoading(false)

                        const entites: any = []
                        const ap: any = []

                        res.Result.map((g: any) => {
                            if (g.Statut != 2) {
                                entites.push({ id: g.CodeFiliale, CodeFiliale: g.CodeFiliale, Libelle: g.Libelle, DateCreated: g.DateCreated, Statut: g.IsActif, HeadFiliale: g.HeadFiliale, Actions: g.CodeFiliale, Location: g.Location, Phone: g.Phone }
                                )
                                ap.push({ id: g.CodeFiliale, ModifDate: g.ModifDate, UpdateCount: g.UpdateCount, CreatedBy: g.CreatedBy })
                            }
                        })

                        setDataTri(entites)
                        setArrierePlan(ap)


                    }
                    else {
                        selLoading(false)
                        setDataTri([])
                        setTextRes("")
                        alert.warning(res.Message)
                    }
                })
                .catch((error: any) => {
                    setTextRes("")
                    alert.error('Error', error)
                    selLoading(false)
                    console.log(error);
                });
        }

    }
    function LoadData() {
        const codeAbonne = user.CodeAbonne
        selLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.GetAllFiliales + Crypter.encrypt(codeAbonne),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    selLoading(false)

                    const entites: any = []
                    const ap: any = []

                    res.Result.map((g: any) => {
                        if (g.Statut != 2) {
                            entites.push({ id: g.CodeFiliale, CodeFiliale: g.CodeFiliale, Libelle: g.Libelle, DateCreated: g.DateCreated, Statut: g.Statut, HeadFiliale: g.HeadFiliale, Actions: g.CodeFiliale, Location: g.Location, Phone: g.Phone }
                            )
                            ap.push({ id: g.CodeFiliale, ModifDate: g.ModifDate, UpdateCount: g.UpdateCount, CreatedBy: g.CreatedBy })
                        }
                    })

                    setDataTri(entites)
                    setArrierePlan(ap)


                }
                else {
                    selLoading(false)
                    setDataTri([])
                    //localStorage.setItem("tabGuichet", JSON.stringify([]))
                    setTextRes("")
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                setTextRes("")
                alert.error('Error', error)
                selLoading(false)
                console.log(error);
            });
    }
    const columns: DataTableColumn[] =
        [
            { field: 'CodeFiliale', headerName: 'ID Entité', width: 100 },
            { field: 'Libelle', headerName: 'Libelle', width: 150 },
            { field: 'DateCreated', headerName: 'Date création', width: 150 },
            { field: 'HeadFiliale', headerName: 'Responsable', width: 150 },
            { field: 'Phone', headerName: 'Téléphone', width: 150 },
            { field: 'Location', headerName: 'Localisation', width: 150 },
            {
                field: 'Statut', headerName: 'Statut', width: 70, renderCell: ({ value }) => (
                    <Badge color={value == 1 ? "blue" : "red"}>
                        {value == 1 ? "actif" : "bloqué"}
                    </Badge>
                ),
            },
            {
                field: 'Actions', headerName: 'Actions', width: 150, sortable: false,
                renderCell: ({ value }) => (
                    <div className="flex items-center gap-2">
                        <UpdateEntite handleFunction={() => { LoadData() }} entite={dataTri.find((ar: any) => (ar.id == value))} />
                        <BlockDeblockEntite handleFunction={() => { LoadData() }} entite={dataTri.find((ar: any) => (ar.id == value))} />
                    </div>
                ),
            },
        ];

    function handleRowClick(e: any) {
        setArrierePlanSelected(arrierePlan.find((ar: any) => (ar.id == e.id)))
    }

    const [open, setOpen] = useState(false)
    const [entite, setEntite] = useState<any>()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Spin spinning={loading} >
            <PageHeader
                title="Gestion des entités"
                subtitle="Paramétrez les filiales, leurs informations et leur statut"
                actions={<AddEntite handleFunction={() => { LoadData() }} />}
            />
            <div className="eb-table-wrap">
                <SearchInput onSearch={Search} size='lg' className="mb-3" placeholder='Saisissez pour effectuer une recherche profonde' />
                <DataTable onRowClick={handleRowClick} rows={dataTri} height={300} columns={columns} searchable />
            </div>
            <TableStatusBar count={dataTri.length} loading={loading} onRefresh={LoadData} />
            <InfoBar data={[
                { label: 'Date Modif', value: arrierePlanSelected?.ModifDate },
                { label: 'Nombre de Modif', value: arrierePlanSelected?.UpdateCount },
                { label: 'Créé par', value: arrierePlanSelected?.CreatedBy },
            ]} />

            <FormDrawer
                open={open}
                onClose={handleClose}
                title={`Modification de l'entité ${entite?.Libelle || ''}`}
                hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
            >
                <FormEntiteUpdate handleFunction={() => { setOpen(false); LoadData() }} entite={entite} />
            </FormDrawer>
        </Spin>
    );
}
